export default "__VITE_ASSET__CU6kkL8C__"